import watch from 'redux-watch'
import * as Actions from './actions/actions'

let getAndValidateMessage = (newVal, supportedMessageType) => {
    //if there is no new value, return null
    if (typeof newVal === 'undefined' )
    {
        return null;
    }

    //if there is no new value, return null
    if (newVal.length === 0)
    {
        return null;
    }

    //Get the last message from array
    let msg = newVal.slice(-1)[0];

    //if there is no last message, or it is not the type supported by processor, return null
    if (typeof msg === 'undefined' ||  typeof msg.message === 'undefined' || msg.message.type.toLowerCase() !== supportedMessageType)
    {
        return null;
    }

    return msg;
}

/**
 * Used for setting up the state watch to see if launch message is received
 * @returns {} 
 */
let setupStateWatchForReceivedMessages = (settings, store, processFunction) => 
{
    let stateLoc = `${settings.stateLocations.ClientCommunicator.Base}.${settings.stateLocations.ClientCommunicator.ReceivedMessages}`;

    let watcher = watch(store.getState, stateLoc);
        
    store.subscribe(watcher((newVal, oldVal, objectPath) =>
    {
        return processFunction(newVal, oldVal, objectPath);
    }));
}

/**
 * Grab the accesskey from the LaunchIva message and put into the state at Conversation tree
 * @returns {} 
 */
let setAccessKey = (settings, store, message) =>
{
    let stateLoc = `${settings.stateLocations.Conversation.Base}.${settings.stateLocations.Conversation.accessKey}`;
    store.dispatch(Actions.PrepareAccessKey(stateLoc, message.accessKey));
}


/**
 * Takes the userData object from the LaunchIva message and saves it as userMetadata in the state
 * @returns {} 
 */
let setUserMetadata= (settings, store, message) =>
{
    let stateLoc = `${settings.stateLocations.Conversation.Base}.${settings.stateLocations.Conversation.userMetadata}`;
    store.dispatch(Actions.PrepareUserMetadata(stateLoc, message.userData));
}

    /**
 * Dispatches action to apply language provided by launch message into redux state
 * @returns {} 
 */
let setLanguage = (settings, store, message) =>
{
    let stateLoc = `${settings.stateLocations.Conversation.Base}.${settings.stateLocations.Conversation.language}`;
    store.dispatch(Actions.PrepareLanguage(stateLoc, message.language));
}

let isActiveSession = (settings, store) =>
{
    let forceIsActiveSession = store.getState()
        [settings.stateLocations.WelcomeUser.Base]
        [settings.stateLocations.WelcomeUser.forceIsActiveSession];

    let history = store.getState()
        [settings.stateLocations.History.Base]
        [settings.stateLocations.History.Messages] || [];

    return forceIsActiveSession || history.length > 0;
}

let setIsProcessed = (settings, store, message) =>
{
    let stateLocation = settings.stateLocations.ClientCommunicator.ReceivedMessages;

    store.dispatch(Actions.SetIsProcessed(stateLocation, message));
}

export {
    getAndValidateMessage,
    setupStateWatchForReceivedMessages,
    setAccessKey,
    setUserMetadata,
    setLanguage,
    isActiveSession,
    setIsProcessed
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage.js